<template>
  <loading :loading="isLoading" message="Loading your stats and leaderboard">
    <error :error="error"/>
    <div class="home" v-if="page">
      <top-level-stats :statistics="page.TopLevelStats[0]"/>
      <next-scan-date :nextscan="page.NextScanDate[0]"/>
      <b-row style="margin-top: 60px;">
        <b-col md="7" sm="12">
          <priority-list :list="page.PriorityList"/>
        </b-col>
        <b-col md="5" sm="12">
          <leader-board :results="page.TotalSavingsFromAuthority"/>
        </b-col>
      </b-row>
    </div>
  </loading>
</template>

<script>
import TopLevelStats from '../components/TopLevelStats.vue'
import NextScanDate from '../components/NextScanDate.vue'
import PriorityList from '../components/PriorityList.vue'
import LeaderBoard from '../components/LeaderBoard.vue'
import Loading from '../components/Loading.vue'
import Error from '../components/Error.vue'
import OidcConfig from '@/store/oidc-config'

export default {
  name: 'home',
  components: { TopLevelStats, NextScanDate, PriorityList, LeaderBoard, Loading, Error },
  data() {
    return {
      isLoading: true,
      error: null,
      page: null,
    };
  },
  mounted() {
    this.$store.dispatch('getCache', {
      name: 'home',
      fallback: () => {
        this.isLoading = true;
        const { access_token } = this.$store.state.oidcStore;
        return this.$reportingApi.renderPage('panessex', access_token, {
          pageName: 'Home',
        })
        .then((page) => {
          this.$store.commit('cache', { name: 'home', item: page });
          return page;
        });
      },
    })
    .then(page => { this.page = page; this.isLoading = false; })
    .catch(e => { 
      this.error = e.message;
      this.isLoading = false;
      // redirect user to access denied error
      // TODO: only needs doing for the home page?
      if (e.message.indexOf('Missing required roles') === 0) {
        document.location = `${OidcConfig.authority}/Home/Error`;
      }
    });
    // NOTE: by placing a finally here, Edge support will be lost <https://github.com/babel/babel/issues/8297>
  },
};
</script>
